import { render } from "./MobileSubpageHeader.vue?vue&type=template&id=e4888130&scoped=true"
import script from "./MobileSubpageHeader.vue?vue&type=script&lang=js"
export * from "./MobileSubpageHeader.vue?vue&type=script&lang=js"

import "./MobileSubpageHeader.vue?vue&type=style&index=0&id=e4888130&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4888130"]])

export default __exports__